
// Sources for the armpit rash and itching article
export const armpitRashItchySources = [
  {
    text: "American Academy of Dermatology: 'Contact dermatitis'",
    link: "https://www.aad.org/public/diseases/eczema/types/contact-dermatitis"
  },
  {
    text: "Mayo Clinic: 'Heat rash'",
    link: "https://www.mayoclinic.org/diseases-conditions/heat-rash/symptoms-causes/syc-20373276"
  },
  {
    text: "Cleveland Clinic: 'Fungal Infections'",
    link: "https://my.clevelandclinic.org/health/diseases/4276-fungal-infections"
  },
  {
    text: "National Eczema Association: 'Understanding Eczema'",
    link: "https://nationaleczema.org/eczema/"
  }
];
